import { ROUTES_EMPLOYEE_OVERVIEWS } from '@/app/data/route_constants';
import { FILTER_SCOPES } from '@/app/data/filter_constants.js';

const overviewRoutes = [
  {
    name: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_ALL_PROJECTS,
    path: 'overview/projects',
    component: () => import('@/app/shared_components/overview/OverviewAllProjectsPage.vue'),
  },
  {
    name: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_TASKS,
    path: 'overview/tasks',
    component: () => import('@/app/_employees/pages/overview/OverviewTasksPage.vue'),
  },
  {
    component: () => import('@/app/_employees/pages/overview/OverviewMilestonesPage.vue'),
    path: 'overview/milestones',
    children: [
      {
        name: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_MILESTONES,
        path: '',
        component: () => import('@/app/_employees/components/overview/OverviewMilestoneTable.vue'),
      },
      {
        name: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_UNIT_MILESTONES,
        path: 'units',
        component: () => import('@/app/_employees/components/overview/OverviewMilestoneUnitTable.vue'),
      },
    ],
  },
  {
    name: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_AFTERCARE,
    path: 'overview/aftercare',
    component: () => import('@/app/_employees/pages/overview/OverviewAftercarePage.vue'),
  },
  {
    name: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_CONVERSATIONS,
    path: 'overview/conversations',
    component: () => import('@/app/_employees/pages/overview/OverviewConversationsPage.vue'),
    meta: { filter_scope: FILTER_SCOPES.TICKETS_ALL_PROJECTS },
  },
  {
    name: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_DECISIONS,
    path: 'overview/decisions',
    component: () => import('@/app/_employees/pages/overview/OverviewDecisionsPage.vue'),
  },
  {
    name: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_DOCUMENTS,
    path: 'overview/documents',
    component: () => import('@/app/_employees/pages/overview/OverviewDocumentsPage.vue'),
  },
  {
    name: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_FAQS,
    path: 'overview/faqs',
    component: () => import('@/app/_employees/pages/overview/OverviewFAQsPage.vue'),
  },
  {
    name: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_FINANCIALS,
    path: 'overview/financials',
    component: () => import('@/app/_employees/pages/overview/OverviewFinancialsPage.vue'),
  },
  {
    name: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_NEWS,
    path: 'overview/news',
    component: () => import('@/app/_employees/pages/overview/OverviewNewsPage.vue'),
  },
  {
    name: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_SURVEYS,
    path: 'overview/surveys',
    component: () => import('@/app/_employees/pages/overview/OverviewSurveysPage.vue'),
  },
];

export default overviewRoutes;
